"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reset = {
    '@global': {
        '*': {
            boxSizing: 'border-box',
            margin: 0,
            padding: 0
        },
        '*::before': {
            boxSizing: 'border-box',
            margin: 0,
            padding: 0
        },
        '*::after': {
            boxSizing: 'border-box',
            margin: 0,
            padding: 0
        },
        html: {
            fontSize: '16px'
        },
        em: {
            fontStyle: 'normal'
        },
        a: {
            textDecoration: 'none'
        },
        ul: {
            listStyle: 'none'
        },
        ol: {
            listStyle: 'none'
        }
    }
};
exports.default = reset;
